<label class="d-flex" style="font-size: 13px" *ngIf="label">{{label}}&nbsp;<span class="label-sub-text">{{labelSubText}}</span></label>
<div class="dropdown dropdown-container">
  <div [ngClass]="(disabled ? 'disabled-dropdown' : isListOpen && !disableInput ? 'd-none' : '') + ' ' + (valid ? '' : 'error-input')"
       id="{{title}}-btn" style="width: 100%;"
       [ngStyle]="{'max-width': width, 'color': disabled ? '#979797' : (value && value[optionLabelField] || placeholder?.trim().length === 0) ? '#16212F' : '#979797'}"
       class="btn dropdown-toggle text-left btn-filter text-truncate"
       [class.input-group]="isInputGroup"
       data-toggle="dropdown" (click)="!disabled && toggleOptions(this)">
    <div class="d-flex align-items-center filter-content">
      <i *ngIf="value && value['icon']" class="mr-3 value-icon-box" [ngClass]="value['icon']"></i>
      <div class="add-ellipsis">{{value && value[optionLabelField] ? value[optionLabelField] : placeholder?.trim().length > 0 ? placeholder : listItems[0][optionLabelField]}}</div>
    </div>
  </div>
  <div *ngIf="!isListOpen && !valid" style="margin-top: 8px">
    <p style="margin: 0" class="error-text">{{errorMessage}}</p>
  </div>
  <input autocomplete="false" [ngClass]="isListOpen && !disableInput ? '' : 'd-none'" id="{{title}}-input" style="width: 100%" [ngStyle]="{'max-width': width, 'color': '#16212F'}"
         class="btn dropdown-toggle text-left btn-filter"
         [disabled]="disabled || disableInput"
         onfocus="this.value=''"
         (focusout)="toggleChange(this)"
         data-toggle="dropdown" (input)="inputContentChange($event.target.value)">
  <div id="{{title}}" class="dropdown-menu dropdown-options" [ngClass]="dropdownOptionsPosition ? dropdownOptionsPosition : ''" [ngStyle]="{'max-height': maxHeight,'max-width': width, 'color': '#16212F'}" style="width: 100%; will-change: unset !important; transform: unset !important;">
    <beaconstac-options [value]="value"
                        [optionsPosition]="dropdownOptionsPosition"
                        (valueChange)="setValue($event)"
                        [listItems]="filteredListItems"
                        [maxWidth]="width"
                        [maxHeight]="maxHeight"
                        [optionValueField]="optionValueField"
                        [optionLabelField]="optionLabelField"
                        [optionsType]="optionsType"
                        [enableInfiniteScrolling]="enableInfiniteScrolling"
                        (fetchMoreData)="getMoreData($event)"
                        [isFetchingData]="isFetchingData"
                        [optionsHeaderText]="optionsHeaderText"
                        (stickyCTAClicked)="handleStickCTAClick($event)"
                        [stickyCTAText]="stickyCTAText"
    >
    </beaconstac-options>
  </div>

</div>
